import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactPlayer from 'react-player';

import { Loading } from './Loading';
import { useResultContext } from '../contexts/ResultContextProvider';

export const Results = ({resNum}) => {
  const { results, isLoading, getResults, searchTerm } = useResultContext();
  const location = useLocation();

  useEffect(() => {

    if (searchTerm) {
      if (location.pathname === '/videos') {
        getResults(`/search/q=${searchTerm}videos`)
      } else {
        getResults(`${location.pathname}/q=${searchTerm}&num=${resNum}`)
      }
    }
  }, [searchTerm, location.pathname, resNum])

  if (isLoading) return <Loading />

  switch (location.pathname) {
    case '/search':
      return (
        <div className='flex flex-wrap justify-between space-y-8 sm:px-56'>
          {results?.map(({ link, title, description }, index) => (
            <div key={index} className='md:w-2/5 w-full'>
              <a href={link} target="_blank" rel="noreferrer">
                <p className='text-sm'>
                  {link?.length > 30 ? link.substring(0, 30) : link}
                </p>
                <p className='text-lg hover:underline dark:text-blue-300 text-blue-700'>
                  {title}
                </p>
              </a>
              <p className='text-sm break-words mt-2'>
                {description}
              </p>
            </div>
          ))}
        </div>
      )
    case '/images':
      return (
        <div className="flex flex-wrap justify-center items-center">
          {results?.map(({ image, link: { href, title } }, index) => (
            <a className='sm:p-3 p-5 hover:underline' href={href} key={index} target="_blank" rel='noreferrer'>
              <img src={image?.src} alt={title} loading="lazy" />
              <p className="w-36 break-words text-sm mt-2">
                {title}
              </p>
            </a>
          ))}
        </div>
      )
    case '/news':
      return (
        <div className='flex flex-wrap justify-between space-y-8 sm:px-56 items-center'>
          {results?.map(({ links, id, source, title, published, summary }) => (
            <div key={id} className='md:w-2/5 w-full border rounded-md p-6'>
              <a href={links?.[0].href} target="_blank" rel="noreferrer" className='hover:underline'>
                <p className='text-sm'>
                  {source?.title}
                </p>
                <p className='text-lg dark:text-blue-300 text-blue-700'>
                  {title}
                </p>
              </a>
              <div className='flex gap-4'>
                <a href={source?.href} target='_blank' rel='noreferrer'>
                  {source?.href}
                </a>
              </div>
              <p className='text-xs'>
                {published}
              </p>
            </div>
          ))}
        </div>
      )
    case '/videos':
      return (
        <div className='flex flex-wrap'>
          {results?.map((videos, index) => (
            <div key={index} className='p-2'>
              {videos?.additional_links?.[0]?.href && <ReactPlayer url={videos.additional_links?.[0].href} controls width='400px' height='300px'></ReactPlayer>}
            </div>
          ))}
        </div>
      )
    default:
      return 'ERROR!';
  }
};
